import { NOTIFICATION_SUCCESS, REMOVE_NOTIFICATION } from '../slices/notificationSlice';
export const notificationAction = (data) => async (dispatch) => {
    dispatch(NOTIFICATION_SUCCESS(data));
};
export const notificationRemoveAction = (data) => async (dispatch) => {
    dispatch(REMOVE_NOTIFICATION(data));
};
